import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import  { DistrictHistoriessView } from "./districtHistoriess-view"

export class DistrictHistoriessViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'باز کردن و بستن شعب';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.districts = ObservableArray.create<district>();
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new DistrictHistoriessView();
    }
    public getTypeId(): string {
        return "VM-AF14FC02-EFD9-4922-964C-D49482C5EFD8"
    }
    public set districts(v: ObservableArray<district>) { this._districts = v; } public get districts(): ObservableArray<district> { return this._districts;} private _districts: ObservableArray<district>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.refreshPaged();
    }
    async refreshPaged(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllDistrictHistories',{});
            this.districts.update(...result.DistrictHistories.map(q=>{
                let r = new district(this);
                r.id = q.Id;
                r.districtName = q.DistrictName;
                r.districtId = q.DistrictId;
                r.isOpened = q.IsOpened;
                r.openerOperatorName = q.OpenerOperatorName;
                r.closerOperatorName = q.CloserOperatorName;
                r.openTime = moment.utc(q.OpenTime);
                r.closeTime = q.CloseTime == null ? null : moment.utc(q.CloseTime);
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async openDistrict(id:string) {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/OpenDistrict',{
                DistrictId:id
            });
            if(result.IsSuccessful==false){
                if (result.Faults[0].Parameters.FaultId === "C6939E00-6AB3-4FC7-91D8-97BCD7438D90")
                    throw "امکان بازگشایی وجود ندارد.";
                throw "خطا در انجام عملیات";
            }
            await this.messageBoxConfirmSuccess('شعبه بازگشایی شد.','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا');
        } finally {
            this.isLoading = false;
            this.refresh();
        }
    }

    async closeDistrict(id:string) {
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/CloseDistrict',{
                DistrictId:id
            });
            await this.messageBoxConfirmSuccess('شعبه بسته شد.','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.refresh();
        }
    }

    async closeAllDistrict() {
        try {
            let result:string; 
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','بستن شعب');
            if(result=='no'){
                return;
            }
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/CloseAllDistricts',{});
            await this.messageBoxConfirmSuccess('همه شعب بسته شد.','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.refresh();
        }
    }
}

export class district extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:DistrictHistoriessViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent:DistrictHistoriessViewModel;
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set openerOperatorName(v: string) { this._openerOperatorName = v; } public get openerOperatorName(): string { return this._openerOperatorName;} private _openerOperatorName: string;
    public set closerOperatorName(v: string) { this._closerOperatorName = v; } public get closerOperatorName(): string { return this._closerOperatorName;} private _closerOperatorName: string;
    public set openTime(v: moment.Moment) { this._openTime = v; } public get openTime(): moment.Moment { return this._openTime;} private _openTime: moment.Moment;
    public set closeTime(v: moment.Moment) { this._closeTime = v; } public get closeTime(): moment.Moment { return this._closeTime;} private _closeTime: moment.Moment;
    public set isOpened(v: boolean) { this._isOpened = v; } public get isOpened(): boolean { return this._isOpened;} private _isOpened: boolean;
    
    async openDistrict():Promise<void>{
        if(!this.isOpened) {
            let result:string; 
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','بازگشایی شعبه');
            if(result=='yes'){
                this._typedParent.openDistrict(this.districtId);
            }
        }
    }
    
    async closeDistrict():Promise<void>{
        if(this.isOpened) {
            let result:string; 
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','بستن شعبه');
            if(result=='yes'){
                this._typedParent.closeDistrict(this.districtId);
            }
        }
    }
}
